import axios from 'axios';

export const createBaseAxiosClient = (
  url: string,
  responseInterceptor?: (response: any) => any,
  axiosConfig?: any | undefined
) => {
  const client = axios.create({ baseURL: url, withCredentials: true, ...axiosConfig });

  /**
   * Response interceptors
   */
  if (responseInterceptor) {
    client.interceptors.response.use(responseInterceptor, (error) =>
      Promise.reject(
        (error.response && error.response.data) || 'Something went wrong in custom interceptor'
      )
    );
  } else {
    client.interceptors.response.use(
      (response) => response,
      (error) =>
        Promise.reject(
          (error.response && error.response.data) || 'Something went wrong in custom interceptor'
        )
    );
  }

  return client;
};
